var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h2',[_vm._v("TestExport")]),_c('hr'),_c('h2',[_vm._v("I am a remote vue compoent "+_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }